// src/services/settings.ts
import { apiClient } from './api';
import {
  QueueControlStatus,
  UpdateBatchSizeRequest,
  UpdateThreadCountRequest,
  UpdateSendMethodRequest,
  ClearQueueResponse,
  ClearQueueRequest
} from '../types/settings';

class SettingsService {
  async getQueueStatus(): Promise<QueueControlStatus> {
    const response = await apiClient.get<QueueControlStatus>('/settings/queue-status');
    return response.data;
  }

  async pauseQueue(): Promise<void> {
    await apiClient.post('/settings/pause');
  }

  async resumeQueue(): Promise<void> {
    await apiClient.post('/settings/resume');
  }

  // expectedCount is what the operator was shown in the dialog. The API refuses
  // the delete if the real count has moved since, so a stale dialog cannot remove
  // more than they agreed to.
  async clearQueue(expectedCount: number, allCompanies = false): Promise<ClearQueueResponse> {
    const response = await apiClient.post<ClearQueueResponse>('/settings/clear-queue', {
      expectedCount,
      allCompanies,
    } as ClearQueueRequest);
    return response.data;
  }

  async updateBatchSize(batchSize: number): Promise<void> {
    await apiClient.put('/settings/batch-size', { batchSize } as UpdateBatchSizeRequest);
  }

  async updateThreadCount(threadCount: number): Promise<void> {
    await apiClient.put('/settings/thread-count', { threadCount } as UpdateThreadCountRequest);
  }

  async updateSendMethod(sendMethod: 'SmtpRelay' | 'Direct'): Promise<void> {
    await apiClient.put('/settings/send-method', { sendMethod } as UpdateSendMethodRequest);
  }
}

export const settingsService = new SettingsService();
